import { ReportChecklistAccessoriesData } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';

interface Props {
  accessories?: ReportChecklistAccessoriesData[];
  isEmpty?: boolean;
  includeAccessoryColumns?: boolean;
}

const ReportChecklistAccessories: React.FC<Props> = ({
  accessories,
  isEmpty,
  includeAccessoryColumns = true,
}) => {
  const accessoriesSize = accessories?.length;

  return (
    <div className="reportChecklist-accessories">
      <div className="reportChecklist-accessories-header">
        <span>Acessórios</span>
      </div>

      <table className="reportChecklist-accessories-table">
        <thead>
          <tr>
            <th>Nome</th>
            {includeAccessoryColumns && (
              <>
                <th>Sim</th>
                <th>Não</th>
              </>
            )}
            <th>Observação</th>
          </tr>
        </thead>
        <tbody>
          {!isEmpty && !accessoriesSize && (
            <tr>
              <td colSpan={4} className="empty">
                Não há acessórios
              </td>
            </tr>
          )}

          {accessories?.map((item) => (
            <tr key={item.accessoryId}>
              <td>{item.description}</td>
              {includeAccessoryColumns && (
                <>
                  <td>{item.selected && 'X'}</td>
                  <td>{!item.selected && !isEmpty && 'X'}</td>
                </>
              )}
              <td>{item.comment}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportChecklistAccessories;
